module.exports = __webpack_public_path__ + "media/img/help_center/Student_Profile_02-ab1ba858f3a60bf94a2557ef8a071557.jpg";